import CommAndEducation from './CommAndEducation'

export default CommAndEducation
